/**
 * Tawk.to Manager Utility
 * Handles loading, unloading, and interacting with the Tawk.to chat widget
 */

class TawkManager {
  constructor() {
    this.scriptId = 'tawk-script';
    this.widgetLoaded = false;
  }

  /**
   * Load the Tawk.to script
   */
  loadScript() {
    // Check if script is already loaded
    if (document.getElementById(this.scriptId)) {
      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
      try {
        const script = document.createElement('script');
        const firstScript = document.getElementsByTagName('script')[0];
        
        script.id = this.scriptId;
        script.async = true;
        script.src = 'https://embed.tawk.to/694096c9b690c5197ee9d3cc/1jci4q0kv';
        script.charset = 'UTF-8';
        script.setAttribute('crossorigin', '*');
        
        script.onload = () => {
          this.widgetLoaded = true;
          resolve();
        };
        
        script.onerror = () => {
          reject(new Error('Failed to load Tawk.to script'));
        };
        
        firstScript.parentNode.insertBefore(script, firstScript);
      } catch (error) {
        reject(error);
      }
    });
  }

  /**
   * Show the chat widget
   */
  showWidget() {
    if (typeof window.Tawk_API !== 'undefined') {
      try {
        window.Tawk_API.showWidget();
        return true;
      } catch (error) {
        console.warn('Failed to show Tawk widget:', error);
        return false;
      }
    }
    return false;
  }

  /**
   * Hide the chat widget
   */
  hideWidget() {
    if (typeof window.Tawk_API !== 'undefined') {
      try {
        window.Tawk_API.hideWidget();
        return true;
      } catch (error) {
        console.warn('Failed to hide Tawk widget:', error);
        return false;
      }
    }
    return false;
  }

  /**
   * Maximize the chat widget
   */
  maximize() {
    if (typeof window.Tawk_API !== 'undefined') {
      try {
        if (window.Tawk_API.maximize) {
          window.Tawk_API.maximize();
        } else if (window.Tawk_API.toggle) {
          window.Tawk_API.toggle();
        }
        return true;
      } catch (error) {
        console.warn('Failed to maximize Tawk widget:', error);
        return false;
      }
    }
    return false;
  }

  /**
   * Toggle the chat widget
   */
  toggle() {
    if (typeof window.Tawk_API !== 'undefined') {
      try {
        window.Tawk_API.toggle();
        return true;
      } catch (error) {
        console.warn('Failed to toggle Tawk widget:', error);
        return false;
      }
    }
    return false;
  }

  /**
   * Check if widget is loaded and ready
   */
  isReady() {
    return this.widgetLoaded && typeof window.Tawk_API !== 'undefined';
  }
}

// Export singleton instance
export default new TawkManager();